import { render } from "./Science.vue?vue&type=template&id=109b4555&scoped=true"
import script from "./Science.vue?vue&type=script&lang=js"
export * from "./Science.vue?vue&type=script&lang=js"

import "./Science.vue?vue&type=style&index=0&id=109b4555&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-109b4555"

export default script